import React, { useEffect,  useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import {
  Button,
  Card,
  CardBody,
  Select,
  SelectItem,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
//import "react-date-range/dist/styles.css" // main css file
//import "react-date-range/dist/theme/default.css" // theme css file
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { toast } from "react-toastify"
import {  COLUMN_TYPE } from "../../components/NextUITable.jsx"
import { setAccount, setFilter } from "../../state/ledgerSlice.jsx"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components/index.js"
import { useFetchWithBody, useGet, usePost } from "../../api/reactQueryCustomHooks.jsx"
import { apiRoute, linksUrl } from "../../constants/enum.js"

const MultiLedger = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { compCode, startDate, endDate, isMultipleCompany } = useSelector((state) => state.company)
  const { user } = useSelector((state) => state.auth)
  const { filter } = useSelector((state) => state.ledger)
  const [searchAccount, setSearchAccount] = useState(filter && filter.actypeid ? filter.actypeid : "")
  const [filterDate, setFilterDate] = useState({
    start: filter && filter.fromdate ? filter.fromdate : startDate ? startDate : null,
    end: filter && filter.todate ? filter.todate : endDate ? endDate : null
  })
  
  const { isError:isErrorFetch, data: accountType = [] } = useFetchWithBody({
    url: apiRoute.ledger.accountType,
    queryKey: "LedgerAccountType",
  })

  const {
    isPending,
    isError,
    data=[],//ledger = [],
    mutate: filterLedger,
  } = usePost({
    url: apiRoute.ledger.multiLedger.fetch,
    queryKey: "Ledger",
  })

  let downloadDataFooter = {
    Ac_Id: "",
    Ac_Desc: "",
    CompName: "",
  }

  const exportColumns = [
    {
      uid: "Ac_Id",
      name: "Account Id",
    },
    {
      uid: "Ac_Desc",
      name: "Account Description",
    },
    {
      uid: "CompName",
      name: "Company",
    },
  ]


  const funLoadData = () => {

    if (searchAccount) {
      
      filterLedger({
        data: {
          compcode: compCode.join(","),
          dy: 1,
          dbname: user?.clientDB,
          actypeid: searchAccount,
        },
      })
    }
  }


  useEffect(() => {
    if (!isMultipleCompany)
      navigate(linksUrl.ledger.get)
     else
       funLoadData()
  },[])

  const handleFilter = () => {

    if (searchAccount) {
      funLoadData()
      dispatch(setFilter({
        fromdate: new Date(filterDate.start),
        todate: new Date(filterDate.end),
        actypeid: searchAccount,
        actypename: "",
      }))
    } else {
      toast.error("Please select Account Type !", {
        position: "top-center",
      })
    }
  }

  // const handleDataChange = ({ data, isFilter }) => {
  //   if (isFilter)
  //     setData(data)
  //   else {
  //     setData(ledger)
  //   }
  // }

  // useEffect(() => {
  //   setData(ledger)
  // }, [ledger])

  const INITIAL_VISIBLE_COLUMNS = [
    "Ac_Id",
    "Ac_Desc",
    "CompName",
  ]

  const columns = [
    {
      name: "Account Id",
      uid: "Ac_Id",
      sortable: true,

    },
    {
      name: "Account Description",
      uid: "Ac_Desc",

      type: COLUMN_TYPE.link,
      sortable: true,
      onClick: (row) => {
        navigate(linksUrl.ledger.getAccount)
        let acTypeName = accountType.filter((ele) => ele.actypeid == searchAccount)

        dispatch(
          setFilter({
            fromdate: new Date(filterDate.start),
            todate: new Date(filterDate.end),
            actypeid: searchAccount,
            actypename: acTypeName.length > 0 ? acTypeName[0]?.actypename : "",
            
          })
        )
        dispatch(
          setAccount({
            acId: row.Ac_Id,
            acDesc: row.Ac_Desc,
            compCode:row.CompCode
          })
        )
      },
    },

    {
      name: "Company",
      uid: "CompName",
      sortable: true,
    },
  ]

  if (isPending) {
    return <LoadingCard />
  }

  if (isError || isErrorFetch) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer pageName="Multi Ledger" info={[]} breadcrumbs={[]}>
        {/* filter */}
        <Card shadow="sm" radius="sm" className="mb-3 h-full">
          <CardBody className="p-2">
            <div className="flex flex-wrap items-center gap-2">
              {/* date */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={"Start Date"}
                  views={["day", "month", "year"]}
                  format="DD/MM/YYYY"
                  value={filterDate.start
                    ? dayjs(filterDate.start)
                    : filterDate.start}
                  onChange={(newValue) => {
                    setFilterDate((prev) => {
                      return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                    })
                  }}
                  sx={{ width: "145px" }}
                  slotProps={{ textField: { size: "small" } }}
                />
                <DatePicker
                  label={"End Date"}
                  views={["day", "month", "year"]}
                  format="DD/MM/YYYY"
                  value={filterDate.end
                    ? dayjs(filterDate.end)
                    : filterDate.end}
                  onChange={(newValue) => {
                    setFilterDate((prev) => {

                      return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                    })
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  sx={{ width: "145px" }}
                />
              </LocalizationProvider>
              {/*  end of date */}
              <Select
                isRequired
                size="sm"
                items={accountType ? accountType : []}
                label="Account Type"
                placeholder="Select an Account"
                className="max-w-52"
                selectionMode="single"
                isVirtualized
                onChange={(e) => setSearchAccount(e.target.value)}
                selectedKeys={[searchAccount]}
              >
                {(account) => {
                  return (
                    <SelectItem
                      key={account.actypeid}
                    >
                      {account.actypename}
                    </SelectItem>
                  )
                }}
              </Select>
              <Button
                color="primary"
                startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                onPress={handleFilter}
              //isLoading={isPending}
              >
                Search
              </Button>
            </div>
          </CardBody>
        </Card>

        {/* end of filter */}
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          downloadFileName="Ledger"
          showAdvanceFilter={false}
          id="Ac_Id"
        />
      </MainContainer>
    </div>
  )
}

export default MultiLedger
